import { Contact } from "../Models/Contact";
import { Monitor } from "../Models/Monitor";
import { Product } from "../Models/Product";
import { getApi, postApi } from "./Api";



export const addContact = async (contact:Contact) => {
    try{
        return await postApi<{message:string}>('contact/add-contact',contact)
    }
    catch(error){
        throw error;
    }
}